module.exports = __webpack_public_path__ + "static/trubitsyn-6110fb51ae6aa1d9a6a3f48122ffaa69.jpg";